import React, { useEffect, useState } from 'react'
import { EmptyTransactionModel, ITransactionModal } from './TransactionsApp'
import BasicDataViewer, { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import ItemsApp, { IItemModel } from '../items/ItemsApp'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import GenerateTransactionDestination from './GenerateTransactionDestination'
import UsersApp from '../user/UsersApp'
import DateAndTime from '../DateAndTime'
import ProjectsApp from '../projects/ProjectsApp'
import WarehousesApp from '../warehouses/WarehousesApp'
import SectionsApp from '../sections/SectionsApp'
import LocationsApp from '../locations/LocationsApp'

interface IProps extends ITransactionModal {

}

export default function TranscationDetails(props: IProps) {

    const dispatch = useDispatch()

    const [transaction, setTransction] = useState<ITransactionModal>(EmptyTransactionModel)

    const { item_id, user_id, action, type, timestamp, warehouse_id, section_id, location_id, original_warehouse_id, original_section_id, original_location_id, original_user_id, project_id, quantity, note } = transaction

    const [item, setItem] = useState<IItemModel>()
    const [userName, setUserName] = useState<string>("")
    const [projectTitle, setProjectTitle] = useState<string>("")

    const itemsApp = new ItemsApp()
    const userApp = new UsersApp()
    const projectsApp = new ProjectsApp()
    const warehousesApp = new WarehousesApp()
    const sectionsApp = new SectionsApp()
    const locationsApp = new LocationsApp()

    const dateAndTime = new DateAndTime()

    const returnQntSymbol = () => {
        if (type == "stock-adjustment"){
            if (action == "new-item"){
                return "+"
            }
            if (action == "reduce-stock"){
                return "-"
            }
        }
        return ""
    }
    
    const details: IBasicDataViewItem[] = [
        {
            type: "text",
            label: "Item",
            value: item?.title ? item.title : "",
            loading: item?.title ? false : true
        },
        {
            type: "text",
            label: "Quantity",
            value: `${returnQntSymbol()}${quantity}`
        },
        {
            type: "status",
            label: "Transaction Action",
            value: action,
        },
        {
            type: "status",
            label: "Transaction Type",
            value: type
        },
        {
            type: "text",
            label: "Origin",
            value: "",
            customContent: () => {
                return <GenerateTransactionDestination transcation={transaction} showOrigin />
            }
        },
        {
            type: "text",
            label: "Destination",
            value: "",
            customContent: () => {
                return <GenerateTransactionDestination transcation={transaction} />
            }
        },
        {
            type: "text",
            label: "User",
            value: userName ? userName : "-",
            loading: user_id ? userName ? false : true : false
        },
        {
            type: "text",
            label: "Date",
            value: typeof timestamp === "string" ? dateAndTime.formatDateAndTime(timestamp ? new Date(timestamp).toString() : "") : timestamp
        },
        {
            type: "text",
            label: "Project",
            value: projectTitle,
            loading: project_id ? projectTitle ? false : true : false
        },
        {
            type: "text",
            label: "Note",
            value: note
        }
    ]

    useEffect(() => {
        if (item_id){
            itemsApp.singleInstanceDetails(item_id)
                .then(response => {
                    setItem(response.data)
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }, [item_id])

    useEffect(() => {
        if (user_id){
            userApp.singleInstanceDetails(user_id)
                .then(response => {
                    setUserName(response.data.full_name)
                    setTransction({
                        ...transaction,
                        user_full_name: response.data.full_name
                })
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }, [user_id])

    useEffect(() => {
        if (project_id){
            projectsApp.singleInstanceDetails(project_id)
                .then(response => {
                    setProjectTitle(response.data.title)
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }, [project_id])

    useEffect(() => {
        setTransction(props)
    }, [props])

    /**
     * Update origin
     */
    useEffect(() => {

        if (!transaction.original_warehouse_title){
            if (original_warehouse_id){
                warehousesApp.singleInstanceDetails(original_warehouse_id)
                    .then(response => {
                        setTransction({
                            ...transaction,
                            original_warehouse_title: response.data.title
                        })
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }
        }

        if (!transaction.original_section_title){
            if (original_section_id){
                sectionsApp.singleInstanceDetails(original_section_id)
                    .then(response => {
                        setTransction({
                            ...transaction,
                            original_section_title: response.data.title
                        })
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }
        }

        if (!transaction.original_location_title){
            if (original_location_id){
                locationsApp.singleInstanceDetails(original_location_id)
                    .then(response => {
                        setTransction({
                            ...transaction,
                            original_location_title: response.data.title
                        })
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }
        }

        if (!transaction.original_user_title){
            if (transaction.original_user_id){
                userApp.singleInstanceDetails(transaction.original_user_id)
                    .then(response => {
                        setTransction({
                            ...transaction,
                            original_user_title: response.data.title
                        })
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }
        }

    }, [transaction])

    return(
        <div className="transcation-details-box-container">
            <div className="content-of-transcation-details-box-container">
                <BasicDataViewer items={details} />
            </div>
        </div>
    )
}